<div class="header">
  <div class="header__actions-left">
    <rx-icon class="header__actions-left__close" name="close" (click)="closeClicked()"></rx-icon>
  </div>
  <div class="header__title">
    <h3>{{ payload.title }}</h3>
    <span>{{ payload.subTitle }}</span>
  </div>
  <div class="header__actions-right"></div>
</div>
<div class="body">
  <div class="signature_container">
    <rx-button class="light-blue signature_container__clear-button" (click)="onClearSignatureClicked()"
      >Clear</rx-button
    >
    <rx-signature #signature (onEndEvent)="onDrawingComplete($event)"></rx-signature>
  </div>
</div>
<div class="footer">
  <rx-button class="blue footer__button" (click)="signFormClicked()">Sign Form</rx-button>
</div>
